import React, { useEffect, useRef, useState } from 'react'
import CustomerList from './CustomerList'
import CustomerSendListPopup from '../../components/CustomerSendListPopup'
import CustomerTemplatePopup from '../../components/CustomerTemplatePopup'
import DateTimePicker from '../../components/DateTimeInputComponent'
import { BASEURL } from '../../config'
import useAccountStore from '../../stores/account'
import axios from 'axios'

const CustomerPage = (props:any) => {
    const {accessToken} = useAccountStore()

    const [selectTab, setselectTab] = React.useState(0)
    const [selectedCustomers, setSelectedCustomers] = useState<any[]>([])
    const [groupedCustomers, setgroupedCustomer] = useState<any[]>([])
    const groupName: { [key: number]: string } = { 0 : "미분류", 1 : "잠재고객", 2 : "신규고객", 3 : "단골고객" }

    const [templetes, setTempletes] = useState<any[]>([])
    const [sendList, setSendList] = useState<any[]>([])

    const selectTabButton = (tabIndex:any) => { 
        if(tabIndex == selectTab) return

        setselectTab(tabIndex)
        setSelectedCustomers([])
    }

    useEffect(()=>{
        // 선택된 고객들을 gradeID를 기준으로 그룹화
        const gC = selectedCustomers.reduce((acc, customer) => {
            const { gradeID } = customer
            
            if (!acc[gradeID]) { acc[gradeID] = []}
            acc[gradeID].push(customer)
            return acc
        }, {})

        setgroupedCustomer(gC)
    },[selectedCustomers])

    const renderGroupedCustomers = () => {
        return Object.keys(groupedCustomers).map((gradeID:any) => {
            const customers = groupedCustomers[gradeID]
            const numericGradeID = parseInt(gradeID, 10)
    
            // 그룹의 길이에 따라 title 설정
            const title = customers.length === 1 
                ? `${customers[0].petName} ${customers[0].petWeight}kg ${customers[0].petAge}개월`
                : `${groupName[numericGradeID]} ${customers.length}`
            
            // 그룹 내의 각 customer에 대해 CustomerItem 렌더링
            return <CustomerItem 
                    key={`${gradeID}`} 
                    title={title} 
                    clickHandler={() => {
                        // 선택한 gradeID의 customer를 모두 제거
                        const newSelectedCustomers = selectedCustomers.filter(c => c.gradeID !== numericGradeID)
                        setSelectedCustomers(newSelectedCustomers)
                    }} 
                />
            
        })
    }
    const CustomerItem = ({ title, clickHandler} : any) => {
        return (
        <div className="cst_item" title={title}>
            <span> {title} </span>
            {clickHandler &&
                <a href="#"onClick={clickHandler}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8.94028 7.99988L13.1403 3.80655C13.2658 3.68101 13.3363 3.51075 13.3363 3.33321C13.3363 3.15568 13.2658 2.98542 13.1403 2.85988C13.0147 2.73434 12.8445 2.66382 12.667 2.66382C12.4894 2.66382 12.3192 2.73434 12.1936 2.85988L8.00029 7.05988L3.80695 2.85988C3.68142 2.73434 3.51115 2.66382 3.33362 2.66382C3.15608 2.66382 2.98582 2.73434 2.86028 2.85988C2.73475 2.98542 2.66422 3.15568 2.66422 3.33321C2.66422 3.51075 2.73475 3.68101 2.86028 3.80655L7.06029 7.99988L2.86028 12.1932C2.7978 12.2552 2.7482 12.3289 2.71436 12.4102C2.68051 12.4914 2.66309 12.5785 2.66309 12.6665C2.66309 12.7546 2.68051 12.8417 2.71436 12.9229C2.7482 13.0042 2.7978 13.0779 2.86028 13.1399C2.92226 13.2024 2.99599 13.252 3.07723 13.2858C3.15847 13.3197 3.24561 13.3371 3.33362 13.3371C3.42163 13.3371 3.50876 13.3197 3.59 13.2858C3.67124 13.252 3.74498 13.2024 3.80695 13.1399L8.00029 8.93988L12.1936 13.1399C12.2556 13.2024 12.3293 13.252 12.4106 13.2858C12.4918 13.3197 12.5789 13.3371 12.667 13.3371C12.755 13.3371 12.8421 13.3197 12.9233 13.2858C13.0046 13.252 13.0783 13.2024 13.1403 13.1399C13.2028 13.0779 13.2524 13.0042 13.2862 12.9229C13.3201 12.8417 13.3375 12.7546 13.3375 12.6665C13.3375 12.5785 13.3201 12.4914 13.2862 12.4102C13.2524 12.3289 13.2028 12.2552 13.1403 12.1932L8.94028 7.99988Z" fill="black"/>
                </svg></a>
            }
        </div>
        )
    }

    const NewSend = () => {
        const [diagnosisTime, setDiagnosisTime] = useState<Date>(new Date()) // 검사일
        const [isChecked, setIsChecked] = useState(false) // 예약여부
        const [content, setContent] = useState('') // 내용
        
        const sendNewMessage = () => {
            if(content === '') {
                alert('내용을 입력해주세요.')
                return
            }

            if(selectedCustomers.length === 0) {
                alert('대상을 선택해주세요.')
                return
            }
            interface CmInfo {
                title: string
                message: string
                recipientList: any[]
                reservationTime?: Date // 선택적 속성으로 추가
            }
            
            // recipientList는 selectedCustomers의 id값만 담아서 보내기
            let cmInfo: CmInfo = {
                title: "HospitalMessage",
                message: content,
                recipientList: selectedCustomers.map(c => c.userID).sort(),
                ...(isChecked && { sendAt: diagnosisTime }) // 조건부 속성 추가
            }

            axios.post(`${BASEURL}/cm/submit`, {cmInfo:cmInfo}, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    // const data = obj.data
                    isChecked ? alert(`예약메세지가 전송되었습니다.`) : alert(`메시지가 전송되었습니다.`)
                    
                    // 초기화
                    setContent('')
                    setSelectedCustomers([])
                    setIsChecked(false)
                    setDiagnosisTime(new Date())
                }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })            
        }

        return (
            <div className="new_send">
            <form action="#">
            <textarea placeholder="내용을 입력해주세요." value={content} onChange={(e) => setContent(e.target.value)}/> 
            <div className="msg_date">       
                <div className='date_container'>
                    <label htmlFor="send_date">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M7.2 9.6C6.97333 9.6 6.78347 9.5232 6.6304 9.3696C6.4768 9.21653 6.4 9.02667 6.4 8.8C6.4 8.57333 6.4768 8.3832 6.6304 8.2296C6.78347 8.07653 6.97333 8 7.2 8C7.42667 8 7.6168 8.07653 7.7704 8.2296C7.92347 8.3832 8 8.57333 8 8.8C8 9.02667 7.92347 9.21653 7.7704 9.3696C7.6168 9.5232 7.42667 9.6 7.2 9.6ZM4 9.6C3.77333 9.6 3.5832 9.5232 3.4296 9.3696C3.27653 9.21653 3.2 9.02667 3.2 8.8C3.2 8.57333 3.27653 8.3832 3.4296 8.2296C3.5832 8.07653 3.77333 8 4 8C4.22667 8 4.4168 8.07653 4.5704 8.2296C4.72347 8.3832 4.8 8.57333 4.8 8.8C4.8 9.02667 4.72347 9.21653 4.5704 9.3696C4.4168 9.5232 4.22667 9.6 4 9.6ZM10.4 9.6C10.1733 9.6 9.98347 9.5232 9.8304 9.3696C9.6768 9.21653 9.6 9.02667 9.6 8.8C9.6 8.57333 9.6768 8.3832 9.8304 8.2296C9.98347 8.07653 10.1733 8 10.4 8C10.6267 8 10.8165 8.07653 10.9696 8.2296C11.1232 8.3832 11.2 8.57333 11.2 8.8C11.2 9.02667 11.1232 9.21653 10.9696 9.3696C10.8165 9.5232 10.6267 9.6 10.4 9.6ZM7.2 12.8C6.97333 12.8 6.78347 12.7232 6.6304 12.5696C6.4768 12.4165 6.4 12.2267 6.4 12C6.4 11.7733 6.4768 11.5835 6.6304 11.4304C6.78347 11.2768 6.97333 11.2 7.2 11.2C7.42667 11.2 7.6168 11.2768 7.7704 11.4304C7.92347 11.5835 8 11.7733 8 12C8 12.2267 7.92347 12.4165 7.7704 12.5696C7.6168 12.7232 7.42667 12.8 7.2 12.8ZM4 12.8C3.77333 12.8 3.5832 12.7232 3.4296 12.5696C3.27653 12.4165 3.2 12.2267 3.2 12C3.2 11.7733 3.27653 11.5835 3.4296 11.4304C3.5832 11.2768 3.77333 11.2 4 11.2C4.22667 11.2 4.4168 11.2768 4.5704 11.4304C4.72347 11.5835 4.8 11.7733 4.8 12C4.8 12.2267 4.72347 12.4165 4.5704 12.5696C4.4168 12.7232 4.22667 12.8 4 12.8ZM10.4 12.8C10.1733 12.8 9.98347 12.7232 9.8304 12.5696C9.6768 12.4165 9.6 12.2267 9.6 12C9.6 11.7733 9.6768 11.5835 9.8304 11.4304C9.98347 11.2768 10.1733 11.2 10.4 11.2C10.6267 11.2 10.8165 11.2768 10.9696 11.4304C11.1232 11.5835 11.2 11.7733 11.2 12C11.2 12.2267 11.1232 12.4165 10.9696 12.5696C10.8165 12.7232 10.6267 12.8 10.4 12.8ZM1.6 16C1.16 16 0.7832 15.8435 0.4696 15.5304C0.156533 15.2168 0 14.84 0 14.4V3.2C0 2.76 0.156533 2.38347 0.4696 2.0704C0.7832 1.7568 1.16 1.6 1.6 1.6H2.4V0H4V1.6H10.4V0H12V1.6H12.8C13.24 1.6 13.6168 1.7568 13.9304 2.0704C14.2435 2.38347 14.4 2.76 14.4 3.2V14.4C14.4 14.84 14.2435 15.2168 13.9304 15.5304C13.6168 15.8435 13.24 16 12.8 16H1.6ZM1.6 14.4H12.8V6.4H1.6V14.4Z" fill="black"/>
                        </svg>
                        날짜
                    </label>
                <div style={{width:'150px', background:'#F6F6F6', borderRadius:'10px', padding:'3px 5px'}}>
                    <DateTimePicker selectedDate={diagnosisTime} setSelectedDate={setDiagnosisTime}/>
                </div>
                </div>   
                <div className='date_container'>
                    <label htmlFor="send_date">예약</label>
                    <input type="checkbox" id="rsv" checked={isChecked} onChange={() => setIsChecked(!isChecked)}/>
                </div>
             </div>
             <div className="target">
                 <p>
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                       <path d="M8.19984 8.14658C8.55556 7.83867 8.84087 7.45784 9.03642 7.02993C9.23197 6.60203 9.33318 6.13706 9.33317 5.66658C9.33317 4.78253 8.98198 3.93468 8.35686 3.30956C7.73174 2.68444 6.88389 2.33325 5.99984 2.33325C5.11578 2.33325 4.26794 2.68444 3.64281 3.30956C3.01769 3.93468 2.6665 4.78253 2.6665 5.66658C2.6665 6.13706 2.76771 6.60203 2.96325 7.02993C3.1588 7.45784 3.44412 7.83867 3.79984 8.14658C2.8666 8.56917 2.07481 9.2516 1.51916 10.1123C0.963501 10.973 0.667485 11.9755 0.666504 12.9999C0.666504 13.1767 0.736742 13.3463 0.861766 13.4713C0.98679 13.5963 1.15636 13.6666 1.33317 13.6666C1.50998 13.6666 1.67955 13.5963 1.80458 13.4713C1.9296 13.3463 1.99984 13.1767 1.99984 12.9999C1.99984 11.9391 2.42126 10.9216 3.17141 10.1715C3.92156 9.42135 4.93897 8.99992 5.99984 8.99992C7.0607 8.99992 8.07812 9.42135 8.82826 10.1715C9.57841 10.9216 9.99984 11.9391 9.99984 12.9999C9.99984 13.1767 10.0701 13.3463 10.1951 13.4713C10.3201 13.5963 10.4897 13.6666 10.6665 13.6666C10.8433 13.6666 11.0129 13.5963 11.1379 13.4713C11.2629 13.3463 11.3332 13.1767 11.3332 12.9999C11.3322 11.9755 11.0362 10.973 10.4805 10.1123C9.92486 9.2516 9.13308 8.56917 8.19984 8.14658ZM5.99984 7.66658C5.60427 7.66658 5.2176 7.54929 4.8887 7.32952C4.5598 7.10976 4.30345 6.7974 4.15208 6.43195C4.0007 6.0665 3.9611 5.66437 4.03827 5.2764C4.11544 4.88844 4.30592 4.53208 4.58562 4.25237C4.86533 3.97267 5.22169 3.78219 5.60966 3.70501C5.99762 3.62784 6.39975 3.66745 6.7652 3.81883C7.13066 3.9702 7.44301 4.22655 7.66278 4.55544C7.88254 4.88434 7.99984 5.27102 7.99984 5.66658C7.99984 6.19702 7.78912 6.70573 7.41405 7.0808C7.03898 7.45587 6.53027 7.66658 5.99984 7.66658ZM12.4932 7.87992C12.9198 7.39947 13.1985 6.80595 13.2957 6.17081C13.3929 5.53567 13.3045 4.88597 13.041 4.29992C12.7776 3.71387 12.3504 3.21645 11.8108 2.86753C11.2713 2.51862 10.6424 2.33308 9.99984 2.33325C9.82303 2.33325 9.65346 2.40349 9.52843 2.52851C9.40341 2.65354 9.33317 2.82311 9.33317 2.99992C9.33317 3.17673 9.40341 3.3463 9.52843 3.47132C9.65346 3.59635 9.82303 3.66659 9.99984 3.66659C10.5303 3.66659 11.039 3.8773 11.4141 4.25237C11.7891 4.62744 11.9998 5.13615 11.9998 5.66658C11.9989 6.01674 11.906 6.36052 11.7305 6.66353C11.5551 6.96654 11.3031 7.21817 10.9998 7.39325C10.901 7.45027 10.8184 7.53169 10.7601 7.62975C10.7017 7.7278 10.6695 7.83919 10.6665 7.95325C10.6637 8.06643 10.6898 8.17845 10.7423 8.27876C10.7948 8.37906 10.8719 8.46435 10.9665 8.52659L11.2265 8.69992L11.3132 8.74658C12.1168 9.12773 12.7947 9.73058 13.2672 10.4841C13.7396 11.2377 13.9869 12.1105 13.9798 12.9999C13.9798 13.1767 14.0501 13.3463 14.1751 13.4713C14.3001 13.5963 14.4697 13.6666 14.6465 13.6666C14.8233 13.6666 14.9929 13.5963 15.1179 13.4713C15.2429 13.3463 15.3132 13.1767 15.3132 12.9999C15.3186 11.9769 15.0624 10.9694 14.5688 10.0733C14.0752 9.17717 13.3607 8.42213 12.4932 7.87992Z" fill="black"/>
                     </svg>
                     대상
                 </p>
                 <div className="cst_list">
                    {renderGroupedCustomers()}
                 </div>
             </div>
             <div className="button">
                 <button type="submit" id="send_btn" onClick={sendNewMessage}>보내기</button>
             </div>
            </form>
            </div>
        )
    }
    const [loadedMessage, setLoadedMessage] = useState<any>(null) // 템플릿 불러오기
    const selectTemplateHandler = (templete:any) => {
        setLoadedMessage(templete)
        setSelectedCustomers(templete.recipientList)
    }
    const Template = () => {
        const [diagnosisTime, setDiagnosisTime] = useState<Date>(new Date()) // 검사일
        const [isChecked, setIsChecked] = useState(false) // 예약여부
        const [content, setContent] = useState('') // 내용
        const [title, setTitle] = useState('') // 템플릿명
               
        useEffect(()=>{
            // load saved templates
            if(accessToken === null) return
            
            const loadSavedList = async() =>{
                try {
                    axios.get(`${BASEURL}/cm/list/saved`, { headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }})
                    .then(response => response.data)
                    .then(obj => {  
                        if(obj.status === "success") {
                            const data = obj.data
                            
                            setTempletes((prev) => {
                                 // 동일하면 업데이트 방지, 데이터가 다를 경우에만 업데이트
                                if (JSON.stringify(prev) === JSON.stringify(data)) { return prev }
                                return data 
                            })
                        }
                    })
                    .catch(error => {
                        if(error.response) {
                            // temp error handling
                            if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                            if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                            if(error.response.status === 404) { console.log(error) }
                        }
                        else { console.log(error) }
                })}
                catch(e) { console.log(e) }
            }

            loadSavedList()    
        },[])

        useEffect(() => {
            if(loadedMessage) {
                setTitle(loadedMessage.title)
                setContent(loadedMessage.message)
            }
        },[loadedMessage])


        const removeTemplete = () => {
            if(loadedMessage === null) { return }
            const messageID = loadedMessage.id

            axios.delete(`${BASEURL}/cm/delete`, 
                { headers: {Authorization: `Bearer ${accessToken}`}, data: {messageID: messageID}}).then((response)=>response.data)
                .then((obj)=>{
                    if(obj.status === "success") {
                        alert('템플릿이 삭제되었습니다.')
                        setLoadedMessage(null)
                    }    
                }).catch((error)=>{
                    if(error.response) {
                        // temp error handling
                        if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                        if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                        if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                    }
                    else { console.log(error) }
                })
        }
        const savedHandler = () => {
            if(loadedMessage === null) saveTemplete()
            else updateTemplete()
        }

        const updateTemplete = () => {
            if(loadedMessage === null) { return }
            const messageID = loadedMessage.id

            if(title === '') {
                alert('템플릿명을 입력해주세요.')
                return
            }

            if(content === '') {
                alert('내용을 입력해주세요.')
                return
            }

            if(selectedCustomers.length === 0) {
                alert('대상을 선택해주세요.')
                return
            }
            interface CmInfo {
                title: string
                message: string
                recipientList: any[]
                reservationTime?: Date // 선택적 속성으로 추가
            }
            
            // recipientList는 selectedCustomers의 id값만 담아서 보내기
            let cmInfo: CmInfo = {
                title: title,
                message: content,
                recipientList: selectedCustomers.map(c => c.userID).sort(),
                ...(isChecked && { sendAt: diagnosisTime }) // 조건부 속성 추가
            }

            axios.post(`${BASEURL}/cm/update`, {cmInfo:cmInfo, messageID:messageID}, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    // const data = obj.data
                    alert(`템플릿이 수정되었습니다.`)

                    // 초기화
                    setLoadedMessage(null)
                    setContent('')
                    setSelectedCustomers([])
                    setIsChecked(false)
                    setDiagnosisTime(new Date())
                }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })            
        }

        const saveTemplete = () => {
            if(title === '') {
                alert('템플릿명을 입력해주세요.')
                return
            }

            if(content === '') {
                alert('내용을 입력해주세요.')
                return
            }

            if(selectedCustomers.length === 0) {
                alert('대상을 선택해주세요.')
                return
            }
            interface CmInfo {
                title: string
                message: string
                recipientList: any[]
                reservationTime?: Date // 선택적 속성으로 추가
            }
            
            // recipientList는 selectedCustomers의 id값만 담아서 보내기
            let cmInfo: CmInfo = {
                title: title,
                message: content,
                recipientList: selectedCustomers.map(c => c.userID).sort(),
                ...(isChecked && { sendAt: diagnosisTime }) // 조건부 속성 추가
            }

            axios.post(`${BASEURL}/cm/save`, {cmInfo:cmInfo}, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    // const data = obj.data
                    alert(`템플릿이 저장되었습니다.`)

                    // 초기화
                    setContent('')
                    setSelectedCustomers([])
                    setIsChecked(false)
                    setDiagnosisTime(new Date())
                }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })            
        }

        const sendNewMessage = () => {
            if(content === '') {
                alert('내용을 입력해주세요.')
                return
            }

            if(selectedCustomers.length === 0) {
                alert('대상을 선택해주세요.')
                return
            }
            interface CmInfo {
                title: string
                message: string
                recipientList: any[]
                reservationTime?: Date // 선택적 속성으로 추가
            }
            
            // recipientList는 selectedCustomers의 id값만 담아서 보내기
            let cmInfo: CmInfo = {
                title: "HospitalMessage",
                message: content,
                recipientList: selectedCustomers.map(c => c.userID).sort(),
                ...(isChecked && { sendAt: diagnosisTime }) // 조건부 속성 추가
            }

            axios.post(`${BASEURL}/cm/submit`, {cmInfo:cmInfo}, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    // const data = obj.data
                    isChecked ? alert(`예약메세지가 전송되었습니다.`) : alert(`메시지가 전송되었습니다.`)
                    
                    // 초기화
                    setContent('')
                    setSelectedCustomers([])
                    setIsChecked(false)
                    setDiagnosisTime(new Date())
                }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })            
        }
        
        return (
            <div className='template'>
                <div className='top'>
                    <label htmlFor="template_name">템플릿명</label>
                    <button type="button" id="list_btn" onClick={handleListClick}>목록</button>
                </div>
                <input type="text" id="template_name" placeholder="템플릿을 입력해주세요." value={title} onChange={(e)=>setTitle(e.target.value)}/>
                <label htmlFor="template_content">본문 메시지</label>
                <textarea placeholder="내용을 입력해주세요." value={content} onChange={(e) => setContent(e.target.value)}/>
                <div className="btn_list">
                    <button type="button" id="del_btn" onClick={removeTemplete}>삭제하기</button>
                    <button type="button" id="save_btn" onClick={savedHandler}>템플릿 저장</button>
                </div>
                <div className="msg_date">      
                    <div className='date_container'>
                        <label htmlFor="send_date">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                <path d="M7.2 9.6C6.97333 9.6 6.78347 9.5232 6.6304 9.3696C6.4768 9.21653 6.4 9.02667 6.4 8.8C6.4 8.57333 6.4768 8.3832 6.6304 8.2296C6.78347 8.07653 6.97333 8 7.2 8C7.42667 8 7.6168 8.07653 7.7704 8.2296C7.92347 8.3832 8 8.57333 8 8.8C8 9.02667 7.92347 9.21653 7.7704 9.3696C7.6168 9.5232 7.42667 9.6 7.2 9.6ZM4 9.6C3.77333 9.6 3.5832 9.5232 3.4296 9.3696C3.27653 9.21653 3.2 9.02667 3.2 8.8C3.2 8.57333 3.27653 8.3832 3.4296 8.2296C3.5832 8.07653 3.77333 8 4 8C4.22667 8 4.4168 8.07653 4.5704 8.2296C4.72347 8.3832 4.8 8.57333 4.8 8.8C4.8 9.02667 4.72347 9.21653 4.5704 9.3696C4.4168 9.5232 4.22667 9.6 4 9.6ZM10.4 9.6C10.1733 9.6 9.98347 9.5232 9.8304 9.3696C9.6768 9.21653 9.6 9.02667 9.6 8.8C9.6 8.57333 9.6768 8.3832 9.8304 8.2296C9.98347 8.07653 10.1733 8 10.4 8C10.6267 8 10.8165 8.07653 10.9696 8.2296C11.1232 8.3832 11.2 8.57333 11.2 8.8C11.2 9.02667 11.1232 9.21653 10.9696 9.3696C10.8165 9.5232 10.6267 9.6 10.4 9.6ZM7.2 12.8C6.97333 12.8 6.78347 12.7232 6.6304 12.5696C6.4768 12.4165 6.4 12.2267 6.4 12C6.4 11.7733 6.4768 11.5835 6.6304 11.4304C6.78347 11.2768 6.97333 11.2 7.2 11.2C7.42667 11.2 7.6168 11.2768 7.7704 11.4304C7.92347 11.5835 8 11.7733 8 12C8 12.2267 7.92347 12.4165 7.7704 12.5696C7.6168 12.7232 7.42667 12.8 7.2 12.8ZM4 12.8C3.77333 12.8 3.5832 12.7232 3.4296 12.5696C3.27653 12.4165 3.2 12.2267 3.2 12C3.2 11.7733 3.27653 11.5835 3.4296 11.4304C3.5832 11.2768 3.77333 11.2 4 11.2C4.22667 11.2 4.4168 11.2768 4.5704 11.4304C4.72347 11.5835 4.8 11.7733 4.8 12C4.8 12.2267 4.72347 12.4165 4.5704 12.5696C4.4168 12.7232 4.22667 12.8 4 12.8ZM10.4 12.8C10.1733 12.8 9.98347 12.7232 9.8304 12.5696C9.6768 12.4165 9.6 12.2267 9.6 12C9.6 11.7733 9.6768 11.5835 9.8304 11.4304C9.98347 11.2768 10.1733 11.2 10.4 11.2C10.6267 11.2 10.8165 11.2768 10.9696 11.4304C11.1232 11.5835 11.2 11.7733 11.2 12C11.2 12.2267 11.1232 12.4165 10.9696 12.5696C10.8165 12.7232 10.6267 12.8 10.4 12.8ZM1.6 16C1.16 16 0.7832 15.8435 0.4696 15.5304C0.156533 15.2168 0 14.84 0 14.4V3.2C0 2.76 0.156533 2.38347 0.4696 2.0704C0.7832 1.7568 1.16 1.6 1.6 1.6H2.4V0H4V1.6H10.4V0H12V1.6H12.8C13.24 1.6 13.6168 1.7568 13.9304 2.0704C14.2435 2.38347 14.4 2.76 14.4 3.2V14.4C14.4 14.84 14.2435 15.2168 13.9304 15.5304C13.6168 15.8435 13.24 16 12.8 16H1.6ZM1.6 14.4H12.8V6.4H1.6V14.4Z" fill="black"/>
                            </svg>
                            날짜
                        </label>
                        <div style={{width:'150px', background:'#F6F6F6', borderRadius:'10px', padding:'3px 5px'}}>
                            <DateTimePicker selectedDate={diagnosisTime} setSelectedDate={setDiagnosisTime}/>
                        </div>
                    </div>    
                    <div className='date_container'>
                        <label htmlFor="send_date">예약</label>
                        <input type="checkbox" id="rsv" checked={isChecked} onChange={() => setIsChecked(!isChecked)}/>       
                    </div>
                </div>
                <div className="target">
                    <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8.19984 8.14658C8.55556 7.83867 8.84087 7.45784 9.03642 7.02993C9.23197 6.60203 9.33318 6.13706 9.33317 5.66658C9.33317 4.78253 8.98198 3.93468 8.35686 3.30956C7.73174 2.68444 6.88389 2.33325 5.99984 2.33325C5.11578 2.33325 4.26794 2.68444 3.64281 3.30956C3.01769 3.93468 2.6665 4.78253 2.6665 5.66658C2.6665 6.13706 2.76771 6.60203 2.96325 7.02993C3.1588 7.45784 3.44412 7.83867 3.79984 8.14658C2.8666 8.56917 2.07481 9.2516 1.51916 10.1123C0.963501 10.973 0.667485 11.9755 0.666504 12.9999C0.666504 13.1767 0.736742 13.3463 0.861766 13.4713C0.98679 13.5963 1.15636 13.6666 1.33317 13.6666C1.50998 13.6666 1.67955 13.5963 1.80458 13.4713C1.9296 13.3463 1.99984 13.1767 1.99984 12.9999C1.99984 11.9391 2.42126 10.9216 3.17141 10.1715C3.92156 9.42135 4.93897 8.99992 5.99984 8.99992C7.0607 8.99992 8.07812 9.42135 8.82826 10.1715C9.57841 10.9216 9.99984 11.9391 9.99984 12.9999C9.99984 13.1767 10.0701 13.3463 10.1951 13.4713C10.3201 13.5963 10.4897 13.6666 10.6665 13.6666C10.8433 13.6666 11.0129 13.5963 11.1379 13.4713C11.2629 13.3463 11.3332 13.1767 11.3332 12.9999C11.3322 11.9755 11.0362 10.973 10.4805 10.1123C9.92486 9.2516 9.13308 8.56917 8.19984 8.14658ZM5.99984 7.66658C5.60427 7.66658 5.2176 7.54929 4.8887 7.32952C4.5598 7.10976 4.30345 6.7974 4.15208 6.43195C4.0007 6.0665 3.9611 5.66437 4.03827 5.2764C4.11544 4.88844 4.30592 4.53208 4.58562 4.25237C4.86533 3.97267 5.22169 3.78219 5.60966 3.70501C5.99762 3.62784 6.39975 3.66745 6.7652 3.81883C7.13066 3.9702 7.44301 4.22655 7.66278 4.55544C7.88254 4.88434 7.99984 5.27102 7.99984 5.66658C7.99984 6.19702 7.78912 6.70573 7.41405 7.0808C7.03898 7.45587 6.53027 7.66658 5.99984 7.66658ZM12.4932 7.87992C12.9198 7.39947 13.1985 6.80595 13.2957 6.17081C13.3929 5.53567 13.3045 4.88597 13.041 4.29992C12.7776 3.71387 12.3504 3.21645 11.8108 2.86753C11.2713 2.51862 10.6424 2.33308 9.99984 2.33325C9.82303 2.33325 9.65346 2.40349 9.52843 2.52851C9.40341 2.65354 9.33317 2.82311 9.33317 2.99992C9.33317 3.17673 9.40341 3.3463 9.52843 3.47132C9.65346 3.59635 9.82303 3.66659 9.99984 3.66659C10.5303 3.66659 11.039 3.8773 11.4141 4.25237C11.7891 4.62744 11.9998 5.13615 11.9998 5.66658C11.9989 6.01674 11.906 6.36052 11.7305 6.66353C11.5551 6.96654 11.3031 7.21817 10.9998 7.39325C10.901 7.45027 10.8184 7.53169 10.7601 7.62975C10.7017 7.7278 10.6695 7.83919 10.6665 7.95325C10.6637 8.06643 10.6898 8.17845 10.7423 8.27876C10.7948 8.37906 10.8719 8.46435 10.9665 8.52659L11.2265 8.69992L11.3132 8.74658C12.1168 9.12773 12.7947 9.73058 13.2672 10.4841C13.7396 11.2377 13.9869 12.1105 13.9798 12.9999C13.9798 13.1767 14.0501 13.3463 14.1751 13.4713C14.3001 13.5963 14.4697 13.6666 14.6465 13.6666C14.8233 13.6666 14.9929 13.5963 15.1179 13.4713C15.2429 13.3463 15.3132 13.1767 15.3132 12.9999C15.3186 11.9769 15.0624 10.9694 14.5688 10.0733C14.0752 9.17717 13.3607 8.42213 12.4932 7.87992Z" fill="black"/>
                    </svg>
                    대상
                    </p>
                    <div className="cst_list">
                        {renderGroupedCustomers()}
                    </div>
                </div>
                
                <div className="button">
                    <button type="submit" id="send_btn" onClick={sendNewMessage}>보내기</button>
                </div>
            </div>
        )
    }
    // 발송리스트
    const [showSendListDetailPopup, setSendListDetailPopup] = useState(false)
    const [selectSendListData, setSelectSendListData] = useState<any>(null)

    const [showTemplateListPopup, setTemplateListPopup] = useState(false)

    const [coordinates, setCoordinates] = useState({ top: 0, left: 0 })
    const [popupTarget, setPopupTarget] = useState<String|null>(null)
    const sendListDetailPopRef = useRef<HTMLDivElement>(null)
    const templateListPopRef = useRef<HTMLDivElement>(null)
    const handlePopClick = (e:any) => {
        e.stopPropagation()

        const sWidth = window.innerWidth
        const sHeight = window.innerHeight
        
        const oWidth = sendListDetailPopRef.current ? sendListDetailPopRef.current.offsetWidth : 0
        const oHeight = sendListDetailPopRef.current ? sendListDetailPopRef.current.offsetHeight : 0
        
        let divLeft = e.clientX
        let divTop = e.clientY
    
        if (divLeft + oWidth > sWidth) divLeft -= oWidth
        if (divTop + oHeight > sHeight) divTop -= oHeight

        if (divLeft < 0) divLeft = 0
        if (divTop < 0) divTop = 0
    
        setCoordinates({ top: divTop, left: divLeft })
    }
    const handleDetailClick = (e:any) => {
       handlePopClick(e)
       setPopupTarget("detail")
    }

    const handleListClick = (e:any) => {
        handlePopClick(e)
        setPopupTarget("list")
    }

    useEffect(() => { if (coordinates.top !== 0 || coordinates.left !== 0) {
        if(popupTarget === "detail") setSendListDetailPopup(true)
        if(popupTarget === "list") setTemplateListPopup(true)
        if(popupTarget === null) return
    }}, [coordinates])
    
    useEffect(() => {
        setSendListDetailPopup(false)
        setTemplateListPopup(false)
    },[selectTab])

    const SendList = () => {
        useEffect(()=>{
            // load Send List
            if(accessToken === null) return
            
            const loadList = async() =>{
                try {
                    axios.get(`${BASEURL}/cm/list/send`, { headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }})
                    .then(response => response.data)
                    .then(obj => {  
                        if(obj.status === "success") {
                            const data = obj.data
                            setSendList((prev) => {
                                 // 동일하면 업데이트 방지, 데이터가 다를 경우에만 업데이트
                                if (JSON.stringify(prev) === JSON.stringify(data)) { return prev }
                                return data 
                            })
                        }
                    })
                    .catch(error => {
                        if(error.response) {
                            // temp error handling
                            if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                            if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                            if(error.response.status === 404) { console.log(error) }
                        }
                        else { console.log(error) }
                })}
                catch(e) { console.log(e) }
            }

            loadList()    
        },[])

        const renderRecipientList = (recipientList:any) => {
        
            if(recipientList === null) return <></>
            if(recipientList.length === 0) return <></>
            
            // 각각 groupName에 따라서 그룹핑
            
            const grouped = recipientList.reduce((acc:any, cur:any) => {
                if(acc[cur.gradeID]) { acc[cur.gradeID].push(cur) }
                else { acc[cur.gradeID] = [cur] }
                return acc
            }, {})
            
            // grouped의 데이터 렌더링, 각 key는 gradeName[gradeID]로 렌더링, value는 각각의 데이터
            return Object.keys(grouped).map((key) => {
                const customers = grouped[key]
                const numericGradeID = parseInt(key, 10)
                const title = customers.length === 1 
                ? `${customers[0].petName} ${customers[0].petWeight}kg ${customers[0].petAge}개월`
                : `${groupName[numericGradeID]} ${customers.length}`
               
                return <CustomerItem key={`${key}`} title={title}/>
            })
        }

        const formatDateToYYYYMMDDHHMM = (date:any) => {
            if (!date) return ""
          
            const d = new Date(date)
            const year = d.getFullYear()
            const month = (`0${d.getMonth() + 1}`).slice(-2) // 월은 0부터 시작하므로 1을 더해줍니다.
            const day = (`0${d.getDate()}`).slice(-2)
    
            const hours = (`0${d.getHours()}`).slice(-2)
            const minutes = (`0${d.getMinutes()}`).slice(-2)
          
            return `${year}.${month}.${day} ${hours}:${minutes}`
        }

        return (
            <>
            <div className="send_list"> { 
                sendList.map((item, index) => {
                    return (
                    <div className="send_item" onClick={(e)=>{
                        handleDetailClick(e)
                        setSelectSendListData(item)}}>
                        <div className="date">{formatDateToYYYYMMDDHHMM(item.sendAt)}</div>
                        <div className="send_con">
                            {`[${item.title ?? "제목없음"}]`}<br/>
                            {/* 내용 일부 */}
                            {item.message.length > 20 ? 
                                item.message.substring(0, 20) + "..." : item.message}
                        </div>
                        <div className="send_target">
                            <label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8.19984 8.14658C8.55556 7.83867 8.84087 7.45784 9.03642 7.02993C9.23197 6.60203 9.33318 6.13706 9.33317 5.66658C9.33317 4.78253 8.98198 3.93468 8.35686 3.30956C7.73174 2.68444 6.88389 2.33325 5.99984 2.33325C5.11578 2.33325 4.26794 2.68444 3.64281 3.30956C3.01769 3.93468 2.6665 4.78253 2.6665 5.66658C2.6665 6.13706 2.76771 6.60203 2.96325 7.02993C3.1588 7.45784 3.44412 7.83867 3.79984 8.14658C2.8666 8.56917 2.07481 9.2516 1.51916 10.1123C0.963501 10.973 0.667485 11.9755 0.666504 12.9999C0.666504 13.1767 0.736742 13.3463 0.861766 13.4713C0.98679 13.5963 1.15636 13.6666 1.33317 13.6666C1.50998 13.6666 1.67955 13.5963 1.80458 13.4713C1.9296 13.3463 1.99984 13.1767 1.99984 12.9999C1.99984 11.9391 2.42126 10.9216 3.17141 10.1715C3.92156 9.42135 4.93897 8.99992 5.99984 8.99992C7.0607 8.99992 8.07812 9.42135 8.82826 10.1715C9.57841 10.9216 9.99984 11.9391 9.99984 12.9999C9.99984 13.1767 10.0701 13.3463 10.1951 13.4713C10.3201 13.5963 10.4897 13.6666 10.6665 13.6666C10.8433 13.6666 11.0129 13.5963 11.1379 13.4713C11.2629 13.3463 11.3332 13.1767 11.3332 12.9999C11.3322 11.9755 11.0362 10.973 10.4805 10.1123C9.92486 9.2516 9.13308 8.56917 8.19984 8.14658ZM5.99984 7.66658C5.60427 7.66658 5.2176 7.54929 4.8887 7.32952C4.5598 7.10976 4.30345 6.7974 4.15208 6.43195C4.0007 6.0665 3.9611 5.66437 4.03827 5.2764C4.11544 4.88844 4.30592 4.53208 4.58562 4.25237C4.86533 3.97267 5.22169 3.78219 5.60966 3.70501C5.99762 3.62784 6.39975 3.66745 6.7652 3.81883C7.13066 3.9702 7.44301 4.22655 7.66278 4.55544C7.88254 4.88434 7.99984 5.27102 7.99984 5.66658C7.99984 6.19702 7.78912 6.70573 7.41405 7.0808C7.03898 7.45587 6.53027 7.66658 5.99984 7.66658ZM12.4932 7.87992C12.9198 7.39947 13.1985 6.80595 13.2957 6.17081C13.3929 5.53567 13.3045 4.88597 13.041 4.29992C12.7776 3.71387 12.3504 3.21645 11.8108 2.86753C11.2713 2.51862 10.6424 2.33308 9.99984 2.33325C9.82303 2.33325 9.65346 2.40349 9.52843 2.52851C9.40341 2.65354 9.33317 2.82311 9.33317 2.99992C9.33317 3.17673 9.40341 3.3463 9.52843 3.47132C9.65346 3.59635 9.82303 3.66659 9.99984 3.66659C10.5303 3.66659 11.039 3.8773 11.4141 4.25237C11.7891 4.62744 11.9998 5.13615 11.9998 5.66658C11.9989 6.01674 11.906 6.36052 11.7305 6.66353C11.5551 6.96654 11.3031 7.21817 10.9998 7.39325C10.901 7.45027 10.8184 7.53169 10.7601 7.62975C10.7017 7.7278 10.6695 7.83919 10.6665 7.95325C10.6637 8.06643 10.6898 8.17845 10.7423 8.27876C10.7948 8.37906 10.8719 8.46435 10.9665 8.52659L11.2265 8.69992L11.3132 8.74658C12.1168 9.12773 12.7947 9.73058 13.2672 10.4841C13.7396 11.2377 13.9869 12.1105 13.9798 12.9999C13.9798 13.1767 14.0501 13.3463 14.1751 13.4713C14.3001 13.5963 14.4697 13.6666 14.6465 13.6666C14.8233 13.6666 14.9929 13.5963 15.1179 13.4713C15.2429 13.3463 15.3132 13.1767 15.3132 12.9999C15.3186 11.9769 15.0624 10.9694 14.5688 10.0733C14.0752 9.17717 13.3607 8.42213 12.4932 7.87992Z" fill="black"/>
                            </svg>
                            대상
                            </label>
                            <div className="cst_list">
                                {renderRecipientList(item.recipientList ?? [])}
                            </div>
                        </div>
                    </div>
                    )
                })
            }
            </div>
                <CustomerSendListPopup
                popRef={sendListDetailPopRef}
                data={selectSendListData}
                coordinates={coordinates}
                showSendListPopup={showSendListDetailPopup}
                setShowSendListPopup={setSendListDetailPopup}/>
            </>
        )
    }
    
    const tabList = [<NewSend />, <Template />, <SendList />]
    
    return (
        
        <div className="contents" style={{opacity:'0.3', pointerEvents:'none'}}>
        {/** 이부분만 지우면됨 */}
        <div style={{display:'flex', position:'absolute', zIndex:'30', 
            left:'50%', top:'50%', fontWeight:'bolder', fontSize:'32px'}}>준비중입니다</div>
        {/* <div className="contents"> */}
                {/**  메시지 발송 */}
                <div className="send_msg">
                    <div className="tab">
                    <ul>
                        <li className={`${selectTab === 0 ? 'on' : ''}`}>
                            <div onClick={()=>selectTabButton(0)}>신규발송</div>
                        </li>
                        <li className={`${selectTab === 1 ? 'on' : ''}`}>
                            <div onClick={()=>selectTabButton(1)}>템플릿</div>
                        </li>
                        <li className={`${selectTab === 2 ? 'on' : ''}`}>
                            <div onClick={()=>selectTabButton(2)}>발송리스트</div>
                        </li>
                    </ul>
                </div>
                <div className="msg_con">
                    {/** 신규발송, 템플릿, 발송리스트 */}
                    {tabList[selectTab]}
                </div>
            </div>
        {/** 고객 리스트 */}
        <CustomerList
            selectedCustomers= {selectedCustomers}
            setSelectedCustomers={setSelectedCustomers}/>
        <CustomerTemplatePopup
            popRef={templateListPopRef}
            coordinates={coordinates}
            templetes={templetes}
            selectTemplateHandler={selectTemplateHandler}
            showCustomerTemplatePopup={showTemplateListPopup}
            setShowCustomerTemplatePopup={setTemplateListPopup}/>
        </div>
    )
}

export default CustomerPage
